module.exports = __webpack_public_path__ + "static/media/integration.40aa1145.svg";